module.exports = __webpack_public_path__ + "img/project6.1df13749.gif";